<template>
  <div>
    <div class="w3-col l8">
      <sortFilter type="events" v-on:changeDisplayType="changeDisplayType" :showMapOption="true"></sortFilter>

      <template v-if="displayType === 'list'">
        <template v-if="events.upcoming.length && searchFilter === 'all' || events.upcoming.length && searchFilter === 'upcoming'">
          <div class="sectionHeader" ref="upcoming" id="upcoming">
            <h5 style="margin:0;">Upcoming Events</h5>
          </div>
          <events type="upcoming" :social="true" layout="wide" :date="true" :image="true" :showAds="true"></events>
        </template>

        <template v-if="events.past.length && searchFilter === 'all' || events.past.length && searchFilter === 'past'">
          <div class="sectionHeader" ref="past" id="past">
            <h5 style="margin:0;">Past Events</h5>
          </div>
          <events type="past" :social="true" layout="wide" :date="true" :image="true" :showAds="true"></events>
        </template>
        
        <template v-if="!events.past.length && !events.upcoming.length">
          <div class="sectionHeader">
            <h5 style="margin:0;">No Results</h5>
          </div>
          <div class="whiteContainer">
            <p>We did not find any results for the search or filter applied.</p>
          </div>
        </template>
      </template>

      <template v-if="displayType === 'map'">
        <div class="sectionHeader w3-display-container">
          <h5>Event Map</h5>
        </div>
        <div class="whiteContainer" style="margin:0 4px 8px;">
          <div id="map" ref="map" style="min-height:400px; width:100%;"></div>
        </div>
      </template>

    </div>

    <!-- sidebar -->
    <div class="w3-col l4 sidebar">
      <template v-if="width > 600">
        <ads type="sidebar" placement="global"></ads> <!-- TODO: make conditional and add one for only mobile at top -->
        <!-- Attractions -->
        <div class="sectionHeader">
          <h5>Attractions</h5>
        </div>
        <attractions layout="thin" :limit="6"></attractions>

        <!-- Dining -->
        <div class="sectionHeader">
          <h5>Dining</h5>
        </div>
        <dining layout="thin" :limit="6"></dining>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import gmapsInit from '../gmaps'
import events from '@/components/events.vue'
import attractions from '@/components/attractions.vue'
import dining from '@/components/dining.vue'
import sortFilter from '@/components/sortFilter.vue'

export default {
  name: "Events",
  components: {
    events,
    attractions,
    dining,
    sortFilter
  },
  computed: mapState([
    'events',
    'searchFilter'
  ]),
  data() {
    return {
      event: {
        title: "",
        address: "",
        dates: [],
        website: "",
        description: "",
        image: null
      },
      dataLoaded: false,
      displayType: 'list',
      width: window.innerWidth
    }
  },
  created() {
    this.$store.dispatch('getEvents').then((eventData) => {
      this.dataLoaded = true
    })
    this.$store.dispatch('getActiveAds')
    this.$store.commit('setInitSearch', '')
  },
  mounted() {
    if (this.$route.params.scrollPosition) {
      if (this.$refs[this.$route.params.scrollPosition]) {
        this.$refs[this.$route.params.scrollPosition].scrollIntoView()
        window.scrollBy(0, -64)
      }
    }
  },
  methods: {
    viewEvent(event) {
      this.$router.push({ name: 'event-details', params: {event: event} })
    },
    link(type, uid) {
      let sharePage = ""
      if (type === 'fb') {
        sharePage = encodeURI("https://www.facebook.com/sharer.php?u=https://daytonalocal.com/event/" + uid);
      } else if (type === 'tw') {
        sharePage = encodeURI("https://twitter.com/intent/tweet?url=https://daytonalocal.com/event/" + uid);
      } else if (type === 'gp') {
        sharePage = encodeURI("https://plus.google.com/share?url=https://daytonalocal.com/event/" + uid);
      } else {
        // nothing
      }
      return sharePage;
    },
    changeDisplayType(type) {
      this.displayType = type
      if (type === 'map') {
        this.gmap()
      }
    },
    async gmap() {
      const google = await gmapsInit()
      let map = new google.maps.Map(this.$refs['map'], {
        center: {lat: 29.208093, lng: -81.023487},
        zoom: 11
      })
      for (let event of this.events.all) {
        if (event.latlng) {
          let marker = new google.maps.Marker({
            position: event.latlng,
            map: map,
            title: event.title
          })
          let infowindow = new google.maps.InfoWindow({
            content: `
              <div style="padding:8px 12px 20px 0; width:300px;">
                <div class="w3-row">
                  <div class="w3-col s3">
                    <img src="` + event.image + `" alt="` + event.title + `" style="height:50px; width:50px;" />
                  </div>
                  <div class="w3-col s9">
                    <a href="/event-details/` + event.url + `" style="color:#333; text-decoration:none;">` + event.title + `<br/>` + event.address + `</a>
                  </div>
                </div>
              </div>`
          })
          marker.addListener('click', () => {
            infowindow.open(map, marker)
          })
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
